import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    this.observer = new IntersectionObserver(this.toggleSticky.bind(this), { threshold: 1.0 })
    this.observer.observe(this.element)
  }

  disconnect () {
    this.observer.unobserve(this.element)
  }

  toggleSticky (entries, observer) {
    const entry = entries[0]
    this.element.classList.toggle('active', !entry.isIntersecting)
  }
}
